import { useState } from 'react';
import p_nav_previous from '../../Assets/Images/p_navbars.svg';
import { getChatList, getMyProfileDetails, notificationCounts } from '../../Services/api';
import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import p_nav_book_outline from "../../Assets/Images/p_nav_book_outline.svg";
import p_nav_message_outline from "../../Assets/Images/p_nav_message_outline.svg";
import p_nav_notifications_outline from "../../Assets/Images/p_nav_notifications_outline.svg";
import p_nav_about_outline from "../../Assets/Images/p_nav_about_outline.svg";
import p_nav_setting_outline from "../../Assets/Images/p_nav_setting_outline.svg";
import p_nav_location from "../../Assets/Images/p_nav_location.png";
import p_nav_next_outline from "../../Assets/Images/p_nav_next_outline.svg";


const MessengerList = () => {

    const navigate = useNavigate();
    const [chatList, setChatList] = useState([]);
    const [profile, setProfileData] = useState("");
    const [notificationcount, setNotificationcount] = useState("");

    useEffect(() => {
        getChatList().then((res) => {
            setChatList(res.data?.chat_history)

        });
        getMyProfileDetails().then((res) => {
            setProfileData(res.data?.user_details);
        });
        notificationCounts().then((res) => {

            setNotificationcount(res.data);
        });
    }, []);

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const monthNames = [
            "Jan", "Feb", "Mar",
            "Apr", "May", "Jun", "Jul",
            "Aug", "Sep", "Oct",
            "Nov", "Dec"
        ];

        const month = monthNames[date.getMonth()];
        const day = date.getDate();
        const year = date.getFullYear();



        return date.getFullYear() === new Date().getFullYear()
            ? `${month} ${day < 10 ? '0' + day : day}`
            : `${month} ${day < 10 ? '0' + day : day}, ${year}`
    };

    function isYesterday(date) {
        const today = new Date();
        date = new Date(date);

        const yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);

        return date.getDate() === yesterday.getDate() &&
            date.getMonth() === yesterday.getMonth() &&
            date.getFullYear() === yesterday.getFullYear();
    }

    function removeExtraFadeFromOffcanvas() {
        const myOffcanvas = document.getElementById('offcanvasTop');
        myOffcanvas.addEventListener('shown.bs.offcanvas', event => {
            let fade = document.getElementsByClassName('offcanvas-backdrop fade show')
            for (let i = 0; i < fade.length; i++) {
                while (fade.length > 1) {
                    fade[i].remove()
                }
            }
        });
    }



    return (
        <>
            <div className="d-flex justify-content-between align-items-center p-3 p-navbar bg-white shadow-none offcanvas-parentType1">

                <div className="d-flex justify-content-between align-items-center ms-2 me-2">
                    <img src={p_nav_previous} width={'24px'} height={'16px'} alt='Previous Button' role='button' data-bs-toggle="offcanvas" data-bs-target="#offcanvasTop" aria-controls="offcanvasTop" onClick={removeExtraFadeFromOffcanvas} />
                    <div className='ff-balooPaaji2-bold fs-20 ms-2 ps-1'>Messages</div>
                </div>

                <div className="offcanvas offcanvas-start" tabIndex="-1" id="offcanvasTop" aria-labelledby="offcanvasTopLabel" >
                    <div className="offcanvas-body p-0">
                        <Link to={`/dashboard`} className="text-decoration-none">
                            <div className="profileDetails primary-bg p-3 text-white d-flex justify-content-between align-items-center">
                                <div className="d-flex">
                                    <img src={profile?.user_img} width={"84px"} height={"81px"} className='profile' />
                                    <div className="ms-2">
                                        <div className="ff-poppins-semiBold fs-16">
                                            {profile?.user_name}
                                        </div>
                                        <div className="ff-balooPaaji2-regular fs-12">
                                            UID:{profile?.user_id}
                                        </div>  {profile?.user_city &&
                                            <div className="ff-balooPaaji2-regular fs-12">
                                                <img src={p_nav_location} width={"12px"} height={"12px"} className="me-1" />
                                                {profile?.user_city}
                                            </div>
                                        }
                                    </div>
                                </div>
                                <img src={p_nav_next_outline} width={"24px"} height={"24px"} />
                            </div>
                        </Link>

                        <div>
                            <div className="d-flex p-3" role="button" onClick={() => navigate('/')} >
                                <img src={p_nav_book_outline} width={"24px"} height={"24px"} />
                                <div className="ff-poppins-regular fs-16 ms-3">
                                    Bookings Manager
                                </div>
                            </div>

                            <Link to={`/messenger-list`} className="text-decoration-none text-dark">
                                <div className="d-flex p-3" role="button">
                                    <img src={p_nav_message_outline} width={"24px"} height={"24px"} />
                                    <div className="d-flex justify-content-between w-100">
                                        <div className="ff-poppins-regular fs-16 ms-3">Messenger</div>
                                        <p className="p-0 m-0">
                                            {notificationcount.unread_message_count > 0 ?
                                                <span className="notification_count">
                                                    {notificationcount.unread_message_count >= 9 ? "9+" : notificationcount.unread_message_count}
                                                </span> : <></>
                                            }
                                        </p>
                                    </div>
                                </div>
                            </Link>

                            <div className="d-flex sidebar p-3 " role="button" onClick={() => navigate("/notifications", { state: { UserId: profile.user_id } })}>
                                <img src={p_nav_notifications_outline} width={"24px"} height={"24px"}
                                />
                                <div className="d-flex justify-content-between w-100">
                                    <div className="ff-poppins-regular fs-16 ms-3">
                                        Notification
                                    </div>
                                    <p className="">
                                        {notificationcount.unread_count > 0 ?
                                            <span className="notification_count">
                                                {notificationcount.unread_count >= 9 ? "9+" : notificationcount.unread_count}
                                            </span> : <></>
                                        }
                                    </p>
                                </div>
                            </div>

                            <Link to={`/aboutPingle`} className="text-decoration-none text-dark" >
                                <div className="d-flex p-3" role="button">
                                    <img src={p_nav_about_outline} width={"24px"} height={"24px"} />
                                    <div className="ff-poppins-regular fs-16 ms-3">
                                        About Pingle
                                    </div>
                                </div>
                            </Link>

                            <Link to={`/settings`} className="text-decoration-none text-dark">
                                <div className="d-flex p-3" role="button">
                                    <img
                                        src={p_nav_setting_outline}
                                        width={"24px"}
                                        height={"24px"}
                                    />
                                    <div className="ff-poppins-regular fs-16 ms-3">Settings</div>
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>

            <div className='messengerList scroller-style-y'>
                {
                    chatList.map(item => (
                        <div className='item d-flex bg-white w-100' role='button' onClick={() => navigate(`/chat/${item.sender_id}`, { state: { vendorImage: item.sender_image, vendorName: item.sender_name } })}>
                            <img src={item.sender_image} width={'47px'} height={'47px'} className='rounded-circle userImg' />
                            <div className='d-flex justify-content-between w-100'>
                                <div>
                                    <div className='senderName ff-poppins-medium fs-14 text-truncate'>{item.sender_name}</div>
                                    <div className='ff-poppins-light fs-12 message text-truncate'>
                                        {
                                            item.last_message.trim() != ''
                                                ?
                                                <span>{item.last_message}</span>
                                                :
                                                <></>
                                        }
                                    </div>
                                </div>


                                {new Date().setHours(0, 0, 0, 0) === new Date(item.last_msg_date).setHours(0, 0, 0, 0) && (
                                    <div>
                                        <div className='ff-poppins-light fs-10'>{formatDate(item.last_msg_date)}, {item.last_msg_time}</div>
                                        {item.unread_msg_count != 0 &&
                                            <div className=' mgs_count ms-3'>
                                                <span className='mt-1' >{item.unread_msg_count != 0 ? item.unread_msg_count : ""}</span>
                                            </div>
                                        }
                                    </div>
                                )}
                                {
                                    (new Date().setHours(0, 0, 0, 0) !== new Date(item.last_msg_date).setHours(0, 0, 0, 0))
                                    &&
                                    isYesterday(new Date(item.last_msg_date).setHours(0, 0, 0, 0))
                                    && (
                                        <div>
                                            <div className='ff-poppins-light fs-10'>{formatDate(item.last_msg_date)}, {item.last_msg_time}</div>
                                            {item.unread_msg_count != 0 &&
                                                <div className=' mgs_count ms-3'>
                                                    <span className='mt-1' >{item.unread_msg_count != 0 ? item.unread_msg_count : ""}</span>
                                                </div>
                                            }
                                        </div>
                                    )
                                }
                                {/* Other Dates  */}
                                {
                                    (new Date().setHours(0, 0, 0, 0) !== new Date(item.last_msg_date).setHours(0, 0, 0, 0))
                                    &&
                                    !isYesterday(new Date(item.last_msg_date).setHours(0, 0, 0, 0))
                                    && (
                                        <div>
                                            <div className='ff-poppins-light fs-10'>{formatDate(item.last_msg_date)}, {item.last_msg_time}</div>
                                            {item.unread_msg_count != 0 &&
                                                <div className=' mgs_count ms-3'>
                                                    <span className='mt-1' >{item.unread_msg_count != 0 ? item.unread_msg_count : ""}</span>
                                                </div>
                                            }
                                        </div>
                                    )
                                }


                            </div>
                        </div>
                    ))
                }

            </div>


        </>
    )
}

export default MessengerList